export default "__VITE_ASSET__5xiRLtsm__"